import * as Sentry from '@sentry/react';
import ReactGA from 'react-ga4';

// Use build-time environment variable: VITE_TELEMETRY_REPORTING
const TELEMETRY_REPORTING = import.meta.env.VITE_TELEMETRY_REPORTING === 'true';

function initializeGoogleAnalytics() {
  if (TELEMETRY_REPORTING) {
    ReactGA.initialize('G-3LPMYJCBK2');
  } else {
    console.log('GA skipped (TELEMETRY_REPORTING not enabled).');
  }
}

function initializeSentry() {
  if (TELEMETRY_REPORTING) {
    Sentry.init({
      dsn: 'https://0de4f33ad7b5941b32a0ffa7d30376f0@o4509003726389248.ingest.us.sentry.io/4510437669994496',
      environment: 'beta',
      tunnel: '/api/4510437669994496/envelope/',
      integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration({
          maskAllText: false,
          blockAllMedia: false,
        }),
      ],
      tracesSampleRate: 1.0,
      replaysOnErrorSampleRate: 1.0,
      replaysSessionSampleRate: 0.1,
      tracePropagationTargets: [/^https:\/\/.*\.pmcanalytics\.com/],
      sendDefaultPii: true,
    });
    console.log('Sentry initialized.');
  } else {
    console.log('Sentry skipped (TELEMETRY_REPORTING not enabled).');
  }
}

export function initializeTelemetryServices() {
  initializeGoogleAnalytics();
  initializeSentry();
}
